import { useState } from "react";
import { NavLink } from "react-router-dom";
import { CaretIcon } from "./CaretIcon";

const CustomNavLink = ({ name = "", path = null, subNavigation = [] }) => {

    const [isServiceDropdownOpen, setIsServiceDropdownOpen] = useState(false);

    if ((subNavigation || []).length > 0) {
        return (
            <div
                className="relative py-2"
                onMouseEnter={() => {
                    setIsServiceDropdownOpen(true);
                }}
                onMouseLeave={() => { setIsServiceDropdownOpen(false) }}
            >
                <button
                    className="font-inter text-white text-base font-medium lg:text-lg transition-all duration-700 ease-in-out flex flex-row justify-center items-center gap-2 hover:!text-gray-400 focus:!text-gray-400"
                >
                    {name}
                    <CaretIcon isOpen={isServiceDropdownOpen} />
                </button>

                {/* Dropdown Menu Content */}
                {isServiceDropdownOpen && (
                    <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-52 bg-[#171A26] bg-gradient-radial border border-white/20 rounded-md shadow-lg shadow-blue-500/30 z-50 py-1 px-2">
                        {
                            subNavigation.map((subItem, subIndex) => (
                                <NavLink
                                    key={subIndex}
                                    to={subItem.path}
                                    className={({ isActive }) =>
                                        `font-inter block px-4 py-2 my-1 text-sm text-white hover:!text-gray-400 focus:!text-gray-400 hover:bg-white/10 rounded-md ${isActive ? 'font-semibold bg-white/5' : 'font-medium'}`
                                    }
                                    onClick={() => setIsServiceDropdownOpen(false)}
                                >
                                    {subItem.name}
                                </NavLink>
                            ))
                        }
                    </div>
                )}
            </div>
        )
    }

    // Renders Standard NavLink
    return (
        <NavLink
            to={path}
            className={({ isActive }) =>
                `font-inter text-white hover:!text-gray-400 focus:!text-gray-400 text-base lg:text-lg lg:px-2 font-medium${isActive ? ' underline' : ''}`
            }
        >
            {name}
        </NavLink>
    )
}

export { CustomNavLink }